/**
 *
 * Asynchronously loads the component for TaxPayerReportDetail
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxpayerReportDetail = lazyLoad(
  () => import('./index'),
  (module) => module.TaxPayerReportDetail
);
